import * as React from 'react';
import { useQuery } from '@tanstack/react-query';

import { Container } from 'types/Watchlist';
import { getEmptyReturnAvailableByTransaction, PerDiemQueryKeys } from 'services/clients/perDiem';
import { Permission, useHasPermission } from 'utils/permissions';
import axios from 'axios';
import { DisputeTable } from './DisputeTable';
import { Overview } from './Overview';
import { Loading, Error } from './cards';

interface Props {
  container: Container;
}

export const PerDiem: React.FC<Props> = (props) => {
  const { container } = props;

  const hasTablePermission = useHasPermission([Permission.ShipmentWatchListTabSmartPerDiem]);
  const hasFeesPermission = useHasPermission([Permission.ShipmentWatchListDndFees]);

  const [state, setState] = React.useState({
    page: 1,
    pageSize: 25,
  });

  const results = useQuery({
    queryKey: [PerDiemQueryKeys.SmartPerDiemByTransaction, container.transaction, state],
    queryFn: ({ signal }) =>
      getEmptyReturnAvailableByTransaction(
        { transactionId: container.transaction, ...state },
        signal
      ),
    keepPreviousData: true,
    retry: (failureCount, error) => {
      if (axios.isAxiosError(error)) {
        if (error.response?.data?.error) {
          return false;
        }
      }
      return failureCount < 3;
    },
  });

  let inner = null;
  if (results.isLoading) {
    inner = <Loading />;
  } else if (results.isError) {
    inner = <Error error={results.error} />;
  } else if (results.data) {
    inner = hasTablePermission && (
      <DisputeTable
        container={container}
        queryResult={results}
        setPage={(page) => setState((s) => ({ ...s, page: page + 1 }))}
        setPageSize={(pageSize) => setState((s) => ({ ...s, pageSize }))}
        page={state.page - 1}
        pageSize={state.pageSize}
      />
    );
  }

  return (
    <div className="flex flex-col h-full">
      <div className="p-4">
        <Overview
          container={container}
          data={results.data}
          loading={results.isLoading}
          showPerDiem={hasFeesPermission}
        />
      </div>
      {hasTablePermission && inner}
    </div>
  );
};
PerDiem.displayName = 'Shipments.DetailDrawer.Sections.PerDiem';
